<div class="p-4 flex flex-col gap-y-4 basis-full flex-grow app-full-height">
  <h1>Batch Invoice Report</h1>

  <p>
    This report allows you to rollover contracts in bulk. Generate the report, select the contracts you want to rollover
    and then press the "Rollover Selected" button.
  </p>

  <form [formGroup]="reportForm" (ngSubmit)="getDockets()" #formContainer>
    <div fxLayout="row">
      <div fxLayout="column" fxFlex="100" fxFlex.gt-sm="1 1 100" class="dashboard-filter">
        <report-criteria [availableCriteria]="availableCriteria" [criteriaForm]="reportForm"
          fxFlex="100"></report-criteria>
      </div>
      <div fxFlex="0 0 100" fxFlex.gt-sm="0 0 auto" fxLayout="column" fxLayoutGap="8px" fxLayoutAlign="center end">
        <div fxLayout.gt-sm="row" fxLayout="column" fxLayoutGap="8px" fxLayoutAlign="end start">
          <button *ngIf="showRolloverButton$ | async" mat-raised-button color="accent" type="button"
            (click)="showBatchRolloverDialog()" class="ml-2">
            Rollover Selected ({{(selectedDocketIds$ | async)?.length || 0}})
          </button>
          <button mat-flat-button color="primary" id="generate-report" [disabled]="!reportForm.valid">
            Generate
          </button>
        </div>
      </div>
    </div>
  </form>

  <div class="flex flex-col basis-full flex-grow mat-elevation-z8 bg-white">
    <!-- Loading spinner -->
    <div *ngIf="loading$ | async" class="loading-shade">
      <mat-spinner diameter="50"></mat-spinner>
    </div>

    <!-- Main table -->
    <div class="flex-grow overflow-auto">
      <table mat-table [dataSource]="dockets$ | async" matSort class="w-full">

        <!-- Checkbox Column -->
        <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef>
            <mat-checkbox (change)="$event.checked ? toggleAllSelected(true) : toggleAllSelected(false)"
              [checked]="allSelected$ | async" [indeterminate]="indeterminateSelected$ | async"
              [aria-label]="(allSelected$ | async) ? 'Deselect All' : 'Select All'">
            </mat-checkbox>
          </th>
          <td mat-cell *matCellDef="let row">
            <mat-checkbox (click)="$event.stopPropagation()" (change)="toggleSelected(row)"
              [checked]="(selectedIdMap$ | async)[row.id]"
              [aria-label]="(selectedIdMap$ | async)[row.id] ? 'Deselect' : 'Select'">
            </mat-checkbox>
          </td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <!-- Customer Column -->
        <ng-container matColumnDef="full_name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Customer</th>
          <td mat-cell *matCellDef="let element">{{element.full_name}}</td>
          <td mat-footer-cell *matFooterCellDef><strong>Totals</strong></td>
        </ng-container>

        <!-- Contract Column -->
        <ng-container matColumnDef="contract">
          <th mat-header-cell *matHeaderCellDef>Contract</th>
          <td mat-cell *matCellDef="let element">
            <a [routerLink]="['/docket', element.id]">{{ element.id }}</a>
          </td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <!-- Created Date Column -->
        <ng-container matColumnDef="created">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Created Date</th>
          <td mat-cell *matCellDef="let element">{{element.created | amDateFormat:dateFormat}}</td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <!-- Invoice Date Column -->
        <ng-container matColumnDef="closed">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Invoice Date</th>
          <td mat-cell *matCellDef="let element">{{element.closed | amDateFormat:dateFormat}}</td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <!-- Hires Column -->
        <ng-container matColumnDef="hires">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Hires</th>
          <td mat-cell *matCellDef="let element">{{element.hires | hlCurrency:null:1:false | async}}</td>
          <td mat-footer-cell *matFooterCellDef>{{(summaryData$ | async)?.hires | hlCurrency:null:1 | async}}</td>
        </ng-container>

        <!-- Consumables Column -->
        <ng-container matColumnDef="consumables">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Consumables</th>
          <td mat-cell *matCellDef="let element">{{element.consumables | hlCurrency:null:1:false | async}}</td>
          <td mat-footer-cell *matFooterCellDef>{{(summaryData$ | async)?.consumables | hlCurrency:null:1:false |
            async}}</td>
        </ng-container>

        <!-- Deliveries Column -->
        <ng-container matColumnDef="deliveries">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Deliveries</th>
          <td mat-cell *matCellDef="let element">{{element.deliveries | hlCurrency:null:1:false | async}}</td>
          <td mat-footer-cell *matFooterCellDef>{{(summaryData$ | async)?.deliveries | hlCurrency:null:1:false | async}}
          </td>
        </ng-container>

        <!-- Preview Column -->
        <ng-container matColumnDef="preview">
          <th mat-header-cell *matHeaderCellDef>Preview</th>
          <td mat-cell *matCellDef="let element">
            <button mat-icon-button color="primary" (click)="previewDocket(element.id)">
              <mat-icon>visibility</mat-icon>
            </button>
          </td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="toggleSelected(row)"
          [class.selected-row]="(selectedIdMap$ | async)[row.id]"></tr>
        @if(summaryData$ | async) {
        <tr mat-footer-row *matFooterRowDef="displayedColumns; sticky: true"></tr>
        }

        <!-- Row shown when there is no matching data -->
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" colspan="9" class="text-center p-4">
            No data matching the filter criteria
          </td>
        </tr>
      </table>
    </div>

    <mat-paginator [pageSizeOptions]="[10, 25, 50, 100]" [pageSize]="(pageSize$ | async) || 10"
      [length]="(total$ | async) || 0" [pageIndex]="(pageIndex$ | async) || 0" showFirstLastButtons
      aria-label="Select page of dockets">
    </mat-paginator>
  </div>
</div>